const ChartDataCheck = (props) => {
  if (props.isLoading)
    return <div className="loading-data-label">Loading...</div>;

  if (!props.chartData.length) {
    return <div className="no-data-label">There is not data available.</div>;
  }

  return <>{props.children}</>;
};

export default ChartDataCheck;
